import { NgModule, inject } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { IrisEnvironmentService } from '@iris/common/services/environment.service';
import { IrisUserService } from '@iris/common/services/user.service';

@NgModule({
  imports: [],
})
export class IrisSentryIntegrationModule {
  constructor() {
    const envService = inject(IrisEnvironmentService);
    const userService = inject(IrisUserService);

    const env = envService.env;

    if (env.sentryActivated) {
      Sentry.init({
        dsn: env.sentryFrontendDsn,
        beforeSend: (event: Sentry.ErrorEvent, _hint: Sentry.EventHint) => {
          const isNonErrorException = event?.exception?.values?.[0]?.value?.startsWith('Non-Error exception captured');
          if (isNonErrorException) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const serializedEvent: Record<string, any> = event.extra?.__serialized__;

            if (!serializedEvent) {
              return event;
            }

            const realErrMessage = serializedEvent?.error?.message ?? serializedEvent?.message;

            event.exception.values[0].value = realErrMessage;
            event.message = realErrMessage;
          }

          return event;
        },
      });

      Sentry.setUser({ id: userService.me?.id, email: userService.me?.email });

      Sentry.setTag('instance_id', env.instanceId);
      Sentry.setTag('release_version', env.version);
      Sentry.setTag('instance', env.instanceName);
    }
  }
}
